import estetica from "../Recursos/Escuelas/estetica.png";
import sistemas from "../Recursos/Escuelas/sistemas.png";
import salud from "../Recursos/Escuelas/salud.png";
import negocio from "../Recursos/Escuelas/negocio.png";
import arte from "../Recursos/Escuelas/arte.png";
import deporte from "../Recursos/Escuelas/deporte.png";
import infantil from "../Recursos/Escuelas/infantil.png";
import juridicas from "../Recursos/Escuelas/juridicas.png";
import veterianaria from "../Recursos/Escuelas/veterianaria.png";
import aduanas from "../Recursos/Escuelas/aduanas.png";
import turismo from "../Recursos/Escuelas/turismo.png";
import electricos from "../Recursos/Escuelas/eletricos.png";
import comida from "../Recursos/Escuelas/comida.png";

export const OFERTAACADEMICA = [
    {
        nombre: 'Escuela de Estética y Bienestar Humano',
        items: [
            'Técnico laboral por competencias en cosmetología y estética integral',
            'Técnico laboral por competencias en estilista integral',
            'Técnico laboral por competencias en barbería'
        ],
        img: estetica
    },
    {
        nombre: 'Escuela de Sistemas y Tecnología',
        items: [
            'Técnico laboral por competencias en desarrollo de software',
            'Técnico laboral por competencias administrador en centro de datos',
            'Técnico laboral por competencias en diseñador web y multimedia'
        ],
        img: sistemas
    },
    {
        nombre: 'Escuela de Ciencias de la Salud',
        items: [
            'Técnico laboral por competencias en salud oral',
            'Técnico laboral por competencias en administrativo en salud',
            'Técnico laboral por competencias en enfermería',
            'Técnico laboral por competencias en auxiliar en salud publica',
            'Técnico laboral por competencias en servicios farmacéuticos'
        ],
        img: salud
    },
    {
        nombre: 'Escuela de Administración y Negocios',
        items: [
            'Técnico laboral por competencias en asistente administrativo',
            'Técnico laboral por competencias en gestión documental',
            'Técnico laboral por competencias auxiliar en banca y finanzas',
            'Técnico laboral por competencias costos y presupuestos',
            'Técnico Laboral por competencias en gestion integrada de la Calidad',
            'Técnico Laboral por competencias en seguridad y Salud en el trabajo',
            'Técnico Laboral por competencias en administración',
            'Técnico laboral por competencias en contabilidad y finanzas con énfasis en NIIF',
            'Técnico laboral por competencias en gestión de entidades bancarias y financieras',
            'Técnico laboral por competencias en organización de eventos',
            'Técnico laboral por competencias en gestión del talento Humano'
        ],
        img: negocio
    },
    {
        nombre: 'Escuela de Diseño y Arte',
        items: [
            'Técnico laboral por competencias diseño de modas',
            'Técnico laboral por competencias confección industrial en prendas de vestir',
            'Técnico laboral por competencias en diseño grafico'
        ],
        img: arte
    },
    {
        nombre: 'Escuela de Deporte y Actividad Física',
        items: [
            'Técnico laboral por competencias en entrenamiento deportivo'
        ],
        img: deporte
    },
    {
        nombre: 'Escuela de la Educación y Desarrollo Infantil',
        items: [
            'Técnico laboral por competencias atención en primera infancia'
        ],
        img: infantil
    },
    {
        nombre: 'Escuela de Ciencias Sociales y Jurídicas',
        items: [
            'Técnico laboral por competencias asistencia legal y jurídico'
        ],
        img: juridicas
    },
    {
        nombre: 'Escuela de Ciencias Agropecuarias y Veterinarias',
        items: [
            'Técnico laboral por competencias en asistente veterinario.'
        ],
        img: veterianaria
    },
    {
        nombre: 'Escuela de Logística y Comercio',
        items: [
            'Técnico laboral por competencias en logística de aduanas',
            'Técnico Laboral por competencias en auxiliar en Comercio exterior',
            'Técnico laboral por competencias en gestión logística'
        ],
        img: aduanas
    },
    {
        nombre: 'Escuela de Turismo y Servicios Aeroportuarios',
        items: [
            'Técnico laboral por competencias en agente de servicio aeroportuario',
            'Técnico laboral por competencias en guía turístico'
        ],
        img: turismo
    },
    {
        nombre: 'Escuela de Industria y Mantenimiento',
        items: [
            'Técnico laboral por competencias en supervisión de redes de distribución de energía eléctrica',
            'Técnico laboral por competencias en electricidad',
            'Técnico laboral por competencias en mantenimiento de redes de gas',
            'Técnico laboral por competencias en desarrollo de sistemas electrónicos industriales',
            'Técnico laboral por competencias en mantenimiento de planta de abastecimiento de agua'
        ],
        img: electricos
    },
    {
        nombre: 'Escuela de Gastronomía y Artes Culinarias',
        items: [
            'Técnico laboral por competencias en procesos gastronómicos',
            'Técnico laboral por competencias en asistente en servicio social y comunitario'
        ],
        img: comida
    }
]